module.exports = __webpack_public_path__ + "img/b2.6bef783d.png";